module.exports = __webpack_public_path__ + "img/analyze.7c5aed20.svg";